// src/services/api/reading.service.ts
import api from '../api';
import { Reading, ReadingFilter, ReadingStats, ReadingAnomaly } from '../../types/reading';
export interface CategoryStats {
  kategorija: string;
  kategorija_naziv: string;
  total_meters: number;
  total_readings: number;
  total_consumption: number;
  avg_procenat: number;
  total_zaduzenje: number;
  total_bill_zaduzenje: number;
  total_uplata: number;
}

export interface PriorityStats {
  prioritet: string;
  prioritet_naziv: string;
  total_meters: number;
  total_consumption: number;
  total_zaduzenje: number;
}

export interface MemberCountStats {
  broj_clanova: string;
  total_meters: number;
  avg_consumption: number;
  total_zaduzenje: number;
}

export interface BillingCategoriesResponse {
  categories: CategoryStats[];
  priorities: PriorityStats[];
  member_counts: MemberCountStats[];
}

export interface ConsumptionAnalysisResponse {
  consumption_analysis: any[];
  financial_summary: {
    total_zaduzenje: number;
    total_uplata: number;
    total_consumption: number;
    avg_procenat: number;
    total_pocetno_stanje: number;
    total_ukupno: number;
  };
  category_info: {
    kategorija: string;
    kategorija_naziv: string;
    prioritet: string;
    prioritet_naziv: string;
    broj_clanova: string;
  };
}

export const readingService = {
  getAll: (filters?: ReadingFilter) => 
    api.get<{ data: Reading[]; total: number }>('/readings', { params: filters }),

  getById: (id: number) => 
    api.get<Reading>(`/readings/${id}`),

  create: (reading: Partial<Reading>) => 
    api.post<Reading>('/readings', reading),

  update: (id: number, reading: Partial<Reading>) => 
    api.put<Reading>(`/readings/${id}`, reading),

  delete: (id: number) => 
    api.delete(`/readings/${id}`),

  getStatistics: (waterMeterId?: number) => 
    api.get<ReadingStats>('/readings/statistics', { params: { water_meter_id: waterMeterId } }),

  getAnomalies: (waterMeterId?: number) => 
    api.get<{ anomalies: ReadingAnomaly[] }>('/readings/anomalies', { params: { water_meter_id: waterMeterId } }),

  getConsumptionAnalysis: (waterMeterId?: number) => 
    api.get<ConsumptionAnalysisResponse>('/readings/consumption', { params: { water_meter_id: waterMeterId } }),

  getBillingCategories: () => 
    api.get<BillingCategoriesResponse>('/readings/billing-categories'),

  getLatestReading: () => 
    api.get<Reading>('/readings/latest'),

  generateBillPdf: (readingId: number) => 
    api.get(`/readings/${readingId}/bill/pdf`, { responseType: 'blob' }),

  updatePaymentStatus: (readingId: number, isPaid: boolean) => 
    api.put<Reading>(`/readings/${readingId}/payment-status`, { is_paid: isPaid }),

  importReadings: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/readings/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // New method to send a direct JSON array of readings
  importReadingsData: (readings: any[]) => {
    // Create a JSON file from the data
    const jsonBlob = new Blob([JSON.stringify(readings)], { type: 'application/json' });
    const jsonFile = new File([jsonBlob], 'readings.json', { type: 'application/json' });
    
    // Use the existing importReadings method
    return readingService.importReadings(jsonFile);
  }
};